import PluginNumber from './PluginNumber';
import './style/index.less';

export default PluginNumber;
